<template>
  <ActionBar :item="normalizedOrder" @detail="$emit('open', order)">
    <Modification v-if="showModification" :order="order" />
    <Cancel
      v-if="showCancel"
      :order="order"
      @orderCanceled="$emit('orderCanceled')"
    />
  </ActionBar>
</template>
<script>
import Icon from 'com/Icon'
import { mapGetters } from 'vuex'
import moment from 'moment-timezone'
import Cancel from './Cancel'
import Modification from './Modification'
import ActionBar from 'mod/ActionBar'

export default {
  components: {
    Icon,
    Cancel,
    Modification,
    ActionBar
  },
  props: {
    orderType: {
      // 0: 待成交订单; 1: 已成交订单；2：已取消订单
      required: true
    },
    order: {
      required: true
    }
  },
  computed: {
    ...mapGetters(['hasValidTradeToken']),
    showModification() {
      return this.orderType === 0
    },
    showCancel() {
      return this.showModification
    },
    normalizedOrder() {
      if (this.order.secType === 'OPT') {
        const expiry = moment
          .tz(this.order.expiry, 'America/New_York')
          .toDate()
          .getTime()
        return Object.assign({}, this.order, { expiry })
      } else {
        return this.order
      }
    }
  },
  watch: {
    'order.originSymbol'() {
      this.cancelConfirmed = false
    }
  }
}
</script>
